export const COMPANY_ADDRESS =
    'Registered office at Room 701, Unit 127, 7/F, Tower B, New Mandarin Plaza, 14 Science Museum Road, Tsim Sha Tsui, Kowloon, Hong Kong.';

export const getCompanyAddress = () => COMPANY_ADDRESS;
